/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_User_TitleInputs */

const en_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove User`)
};

const fr_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l’utilisateur`)
};

const de_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer entfernen`)
};

const it_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi utente`)
};

const ru_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить пользователя`)
};

const es_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar usuario`)
};

const zh_cn2_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除用户`)
};

const ja_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを削除`)
};

const hi_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को हटाएँ`)
};

const pt_pt2_team_manager_remove_user_title = /** @type {(inputs: Team_Manager_Remove_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover usuário`)
};

/**
* | output |
* | --- |
* | "Remove User" |
*
* @param {Team_Manager_Remove_User_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_title = /** @type {((inputs?: Team_Manager_Remove_User_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_remove_user_title(inputs)
	if (locale === "de") return de_team_manager_remove_user_title(inputs)
	if (locale === "it") return it_team_manager_remove_user_title(inputs)
	if (locale === "ru") return ru_team_manager_remove_user_title(inputs)
	if (locale === "es") return es_team_manager_remove_user_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_remove_user_title(inputs)
	if (locale === "ja") return ja_team_manager_remove_user_title(inputs)
	if (locale === "hi") return hi_team_manager_remove_user_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_remove_user_title(inputs)
	return en_team_manager_remove_user_title(inputs)
});